import type {
  BatchGetAccountsRequest,
  BatchGetAccountsResponse,
  BatchUpdateAccountsRequest,
  BatchUpdateAccountsResponse,
  BulkCreateAccountsRequest,
  BulkCreateAccountsResponse,
  ResolveAccountSensitiveDataRequest,
  ResolveAccountSensitiveDataResponse,
  SendAccountRequest,
  SendAccountResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/account_api';
import type { Mandate } from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/mandate_api';
import { awPortfolioManagementApi } from './Base';

const ACCOUNTS_PATH = 'portfolios/v1/accounts';

export function postSendAccounts(request: SendAccountRequest) {
  const path = `${ACCOUNTS_PATH}:send`;
  return awPortfolioManagementApi.post<SendAccountResponse>(path, request);
}

export function postBatchGetAccounts(request: BatchGetAccountsRequest) {
  const path = `${ACCOUNTS_PATH}:batchGet`;
  return awPortfolioManagementApi.post<BatchGetAccountsResponse>(path, request);
}

export function bulkCreateAccounts(request: BulkCreateAccountsRequest) {
  const path = `${ACCOUNTS_PATH}:bulkCreate`;
  return awPortfolioManagementApi.post<BulkCreateAccountsResponse>(path, request);
}

export function updateMandate(mandate: Mandate) {
  const accountId = mandate.parentReference?.account?.accountId;
  const path = `${ACCOUNTS_PATH}/${accountId}/mandate`;
  return awPortfolioManagementApi.put<Mandate>(path, mandate);
}

export function resolveAccountSensitiveData(payload: ResolveAccountSensitiveDataRequest) {
  const path = `${ACCOUNTS_PATH}:resolveSensitiveData`;
  return awPortfolioManagementApi.post<ResolveAccountSensitiveDataResponse>(path, payload);
}

export function batchUpdateAccounts(request: BatchUpdateAccountsRequest) {
  const path = `${ACCOUNTS_PATH}:batchUpdate`;
  return awPortfolioManagementApi.post<BatchUpdateAccountsResponse>(path, request);
}
